import styled from "styled-components";

export const Container = styled.div`
  background: #ffffff;
  border-radius: 8px;
  width: 440px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

  &.vinculo {
    .content {
      padding: 0 24px 24px 24px;
      text-align: center;

      p {
        font-size: 14px;
        line-height: 1.6;
        color: #5e5f5f;
        margin: 0 auto 24px auto;
        max-width: 360px;
      }

      .container-btns {
        display: flex;
        justify-content: center;
        gap: 16px;

        button {
          width: 100px;
        }
      }
    }
  }
`;

export const Header = styled.div`
  padding: 24px 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .container-img-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    img {
      width: 48px;
    }

    h3 {
      font-weight: 600;
      font-size: 18px;
      color: #000;
      text-align: center;
      margin: 0;
    }
  }

  .container-img {
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;

    img {
      width: 12px;
    }
  }
`;
